const screens = {
  mobile: '@media screen and (max-width: 600px)',
};

export default screens;
